// extracted by mini-css-extract-plugin
export var description = "project-module--description--KX0zs";
export var gallery = "project-module--gallery--oouXl";
export var gallerySection = "project-module--gallery-section--s4a8O";
export var goBackLink = "project-module--go-back-link--x4KAZ";
export var nextBtn = "project-module--next-btn--hkVUJ";
export var prevBtn = "project-module--prev-btn--zBLR0";
export var projectInfoSection = "project-module--project-info-section--EZe6t";
export var slide = "project-module--slide--aRlO6";